/** @jsx jsx */
import { jsx } from "@emotion/react";
import { textFieldInputCss } from "../commonStyles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InputComponent = ({ inputRef, ...props }: any) => (
  <input
    data-cy="flowio-text-input"
    {...props}
    css={textFieldInputCss}
    ref={inputRef}
    enterKeyHint="done"
  />
);

export default InputComponent;
